module.exports = __webpack_public_path__ + "static/img/servicesbg3.de4a261.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/servicesbg3.jpg
// module id = fH47
// module chunks = 1